// extracted by mini-css-extract-plugin
export default {"drawer":"LeftMenu_drawer__bzxWf","no-breadcrumbs":"LeftMenu_no-breadcrumbs__Rd9qc"};